<template>
  <div class="photo_view_wrapp flex flex-direction">
    <transition name="slide-up">
      <div class="top flex" v-if="isItemShow" :style="{height:canRevise?'':'100%'}">
        <div class="close" @click="hide">
          <i class="icon-cross"></i>
        </div>
        <div class="prev" @click="prev">
          <i class="icon-left"></i>
        </div>
        <div class="next" @click="next">
          <i class="icon-right"></i>
        </div>
        <div class="flex flex-sub flex-direction cont">
          <div class="title">文件名：{{nowImg.name}}</div>
          <div class="img-wrapp flex justify-center align-center">
            <!-- <div class="bg" :style="{backgroundImage:'url('+nowImg.link+')'}"></div> -->
            <img class="bg" :src="nowImg.link" alt />
          </div>
          <div class="page-count">{{nowItem+1}}/{{allImgList.list.length}}</div>
        </div>
      </div>
    </transition>
    <transition name="slide-down">
      <div class="bottom" v-if="isItemShow">
        <div class="inner flex flex-direction" v-if="canRevise">
          <div class="flex algin-center">
            <div class="checkwrapp" style="margin-right:15px">
              <input
                type="checkbox"
                class="checkInput"
                v-model="nowImg.selected"
                @click="filterData"
                :disabled="!canRevise"
              />
            </div>
            <span class="isCheck">{{nowImg.selected?'已选':'未选'}}</span>
            <span class="slcount">{{selectedCount}}</span>
            <div class="updateAsk" @click="showTips">
              <i class="icon-pencil" v-if="canRevise" style="margin-right:10px"></i>
              <span>{{nowImg.ask?nowImg.ask:canRevise?'添加调修要求':''}}</span>
            </div>
          </div>
          <div class="flex flex-sub align-center" style="padding-top:10px">
            <div class="prev" @click="sliderLeft">
              <i class="icon-left"></i>
            </div>
            <div class="slider-wrapp flex-sub">
              <vue-scroll :ops="ops" class ref="sliderWrapp">
                <div class="slider-content flex">
                  <label
                    class="item flex justify-center align-center"
                    :class="{'active':comp(item.id),'disable':item.list.length==item.limit}"
                    v-for="(item,index) in seletedImgList"
                    :key="index"
                  >
                    <div
                      class="checkwrapp"
                      style="margin-right:10px;vertical-align: text-top;line-height:1"
                      v-if="!(!comp(item.id)&&item.list.length==item.limit)"
                    >
                      <input
                        type="checkbox"
                        class="checkInput"
                        :checked="comp(item.id)"
                        :value="comp(item.id)"
                        :disabled="!canRevise"
                        @change="cekeckr($event,index)"
                      />
                    </div>
                    <div>{{item.category+'-'+item.name+'('+item.list.length+'/'+item.limit+')'}}</div>
                  </label>
                </div>
              </vue-scroll>
            </div>
            <div class="next" @click="sliderRight">
              <i class="icon-right"></i>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import store from "../../store";

export default {
  name: "PhotoViewer",
  data() {
    return {
      ops: {
        vuescroll: {},
        scrollPanel: {},
        rail: {
          keepShow: true
        },
        bar: {
          hoverStyle: true,
          onlyShowBarOnScroll: false, //是否只有滚动的时候才显示滚动条
          background: "#313D4F",
          size: "6px"
          // disable: true
        },
        rail: {
          gutterOfEnds: "1px",
          gutterOfSide: "1px"
        }
      },
      isShow: false,
      isItemShow: false,
      delay: 500,
      nowItem: 0,
      callback: null
    };
  },
  methods: {
    filterData() {
      if (!this.canRevise) return;
      let element = this.nowImg;

      if (element.selectedList.length != 0 && this.nowImg.selected) {
        // 判断照片是否选入相册
        for (let i = 0; i < this.seletedImgList.length; i++) {
          const item = this.seletedImgList[i];
          if (element.selectedList.includes(item.id)) {
            element.selected = false;
            setTimeout(() => {
              element.selected = true;
            });
            // 删除失败
            this.$my_message.show({
              type: "err",
              title: "无法删除",
              data: `<div class='text-18'>此照片已被添加到 <span class='text-orange'>${item.category +
                "-" +
                item.name}</span></div>
                  <div class='text-18'> 无法删除</div>`,
              btns: ["我知道了"],
              close: function(data) {
                console.log("我知道了");
                element.selected = true;
              }
            });
            return false;
          }
        }
      }
    },
    sliderRight() {
      let con = this.$refs.sliderWrapp;
      con.scrollBy(
        {
          dx: 200
        },
        500
      );
    },
    sliderLeft() {
      let con = this.$refs.sliderWrapp;
      con.scrollBy(
        {
          dx: -200
        },
        500
      );
    },
    showTips(e) {
      if (!this.canRevise) return;
      let _this = this;
      this.$my_message.show(
        {
          type: "remark",
          title: "添加调修要求",
          data: _this.nowImg.ask,
          success: function(data) {
            // _this.$emit("bindClick", "ask", {
            //   info: _this.info.index,
            //   data: data
            // });
            store.commit("setImgAsk", {
              id: _this.nowImg.id,
              data: data
            });
          }
        },
        e
      );
    },
    cekeckr(e, index) {
      if (!this.canRevise) return;
      let _this = this;
      var value = e.target.defaultValue;

      if (value == "true") {
        //移除
        store.commit("removeSelectImg", {
          navId: index,
          id: _this.nowImg.id
        });
      } else {
        // 加入照片
        store.commit("addSelectImg", {
          selectIndex: index,
          id: _this.nowImg.id
        });
      }
    },
    prev() {
      if (this.nowItem - 1 < 0) {
        this.nowItem = this.allImgList.list.length - 1;
      } else {
        this.nowItem--;
      }
    },
    next() {
      if (this.nowItem + 1 > this.allImgList.list.length - 1) {
        this.nowItem = 0;
      } else {
        this.nowItem++;
      }
    },
    show(options) {
      if (options) {
        this.callback = options.onhide;
        for (let i = 0; i < this.allImgList.list.length; i++) {
          const element = this.allImgList.list[i];
          if (element.id == options.id) {
            this.nowItem = i;
            break;
          }
        }
      }
      this.isShow = true;
      this.isItemShow = true;
      this.stopScroll();
    },
    hide() {
      var _this = this;
      this.isItemShow = false;
      setTimeout(() => {
        _this.isShow = false;
        document.body.removeChild(_this.$el);
        _this.callback();
        _this.canScroll();
      }, this.delay);
    },
    comp(id) {
      return this.nowImg.selectedList.includes(id);
    },
    //禁止滚动
    stopScroll() {
      var mo = function(e) {
        e.preventDefault();
      };
      document.body.style.overflow = "hidden";
      document.addEventListener("touchmove", mo, false); //禁止页面滑动
    },
    /***取消滑动限制***/
    canScroll() {
      var mo = function(e) {
        e.preventDefault();
      };
      document.body.style.overflow = ""; //出现滚动条
      document.removeEventListener("touchmove", mo, false);
    }
  },
  computed: {
    allImgList() {
      return store.getters.getAllImgList;
    },
    seletedImgList() {
      return store.getters.getSeletedImgList;
    },
    nowImg() {
      return this.allImgList.list[this.nowItem];
    },
    nowItemIscheck() {
      // if(this.nowImg.select)
    },
    selectedCount() {
      let all = this.allImgList;
      let cout = 0;
      for (let index = 0; index < all.list.length; index++) {
        const item = all.list[index];
        if (item.selected) {
          cout++;
        }
      }
      return cout;
    },
    canRevise() {
      return store.getters.getCanRevise;
    }
  }
};
</script>

<style lang="scss" scoped>
.photo_view_wrapp {
  position: fixed;
  width: 100vw;
  height: 100vh;
  min-width: $min-width;
  z-index: 100;
  top: 0;
  left: 0;
  .top {
    background: #1d2333;
    height: calc(100% - 130px);
    position: relative;
    .close {
      position: absolute;
      font-size: 30px;
      color: #9aa2a9;
      top: 50px;
      right: 100px;
      font-weight: bold;
      cursor: pointer;
    }
    .prev,
    .next {
      position: absolute;
      color: #9aa2a9;
      font-weight: bold;
      font-size: 25px;
      background-color: #283140;
      width: 70px;
      height: 70px;
      text-align: center;
      line-height: 70px;
      border-radius: 5px;
      top: 50%;
      cursor: pointer;
      margin-top: -35px;
    }
    .prev {
      left: 80px;
    }
    .next {
      right: 80px;
    }
    .cont {
      font-size: 16px;
      font-family: Source Han Sans CN;
      color: #fff;
      text-align: center;
      .title {
        padding: 40px 0 20px 0;
      }
      .page-count {
        padding: 20px 0 40px 0;
      }
      .img-wrapp {
        height: calc(100% - 152px);
        pointer-events: none;
        .bg {
          border: 10px solid rgba(49, 61, 79, 1);
          border-radius: 5px;
          height: 660px;
          max-height: 100%;
          width: auto;
        }
      }
    }
  }
  .bottom {
    background: #283042;

    .inner {
      padding: 20px 150px;
      height: 130px;
      width: 100%;
      background: #283042;
      .isCheck {
        font-size: 18px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #fff;
        line-height: 22px;
        border-right: 1px solid #7c8ca5;
        padding-right: 15px;
        display: inline-block;
      }
      .slcount {
        font-size: 16px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: rgba(124, 140, 165, 1);
        line-height: 22px;
        vertical-align: top;
        padding: 0 15px;
        padding-right: 20px;
      }
      .updateAsk {
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: rgba(46, 161, 248, 1);
        line-height: 40px;
        line-height: 22px;
        border-bottom: 1px solid #2da1f8;
        min-width: 260px;
        max-width: 300px;
        cursor: pointer;
        word-break: keep-all;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .checkwrapp {
        border-radius: 5px;
        overflow: hidden;
        display: inline-block;
        width: 22px;
        height: 22px;
      }
      .prev,
      .next {
        font-size: 18px;
        font-weight: bold;
        color: #a7b0bf;
        cursor: pointer;
      }
    }
    .slider-wrapp {
      overflow-x: auto;
      margin: 0 10px;
      height: 40px;
      // &::-webkit-scrollbar {
      //   display: none;
      // }
    }
    .slider-content {
      overflow-x: auto;
      white-space: nowrap;
      .item {
        padding: 0 10px;
        margin: 0 10px;
        height: 40px;
        background: rgba(34, 44, 60, 1);
        border: 2px solid rgba(49, 61, 79, 1);
        border-radius: 4px;
        font-size: 16px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: rgba(124, 140, 165, 1);
        text-align: center;
        &.disable {
          background: rgba(49, 61, 79, 1);
          color: #7c8ca5;
          border-color: rgba(49, 61, 79, 1);
        }
        &.active {
          border-color: #1991eb;
          background: linear-gradient(
            0deg,
            rgba(25, 145, 235, 0.4) 0%,
            rgba(46, 161, 248, 0.4) 100%
          );
          color: #fff;
        }
      }
    }
  }
}

.slide-up-enter-active,
.slide-up-leave-active,
.slide-down-enter-active,
.slide-down-leave-active {
  transition: all 0.5s;
}

.slide-up-enter, .slide-up-leave-to /* .fade-leave-active below version 2.1.8 */ {
  transform: translateY(-100%);
}

.slide-down-enter, .slide-down-leave-to /* .fade-leave-active below version 2.1.8 */ {
  transform: translateY(100%);
}
</style>